import { qs, qsa } from './utils.js';
import { saveSchedule, fetchTimeSlots, initClickTimeSlots } from './api.js';

/**
 * Returns an array of US federal holiday Date objects for a given year.
 * Holidays are based on the actual calendar date (no weekend observance shift).
 */
function getUSFederalHolidays (year) {
    const holidays = [];

    const fixed = (month, day) => new Date(year, month, day);

    const nthWeekday = (month, weekday, n) => {
        const d = new Date(year, month, 1);
        let count = 0;
        while (true) {
            if (d.getDay() === weekday) { count++; if (count === n) return d; }
            d.setDate(d.getDate() + 1);
        }
    };

    const lastWeekday = (month, weekday) => {
        const d = new Date(year, month + 1, 0);
        while (d.getDay() !== weekday) d.setDate(d.getDate() - 1);
        return d;
    };

    holidays.push(fixed(0, 1));              // New Year's Day
    holidays.push(nthWeekday(0, 1, 3));      // MLK Day
    holidays.push(nthWeekday(1, 1, 3));      // Presidents' Day
    holidays.push(lastWeekday(4, 1));        // Memorial Day
    holidays.push(fixed(5, 19));              // Juneteenth
    holidays.push(fixed(6, 4));               // Independence Day
    holidays.push(nthWeekday(8, 1, 1));      // Labor Day
    holidays.push(nthWeekday(9, 1, 2));      // Columbus Day
    holidays.push(fixed(10, 11));             // Veterans Day
    holidays.push(nthWeekday(10, 4, 4));     // Thanksgiving
    holidays.push(fixed(11, 25));             // Christmas

    return holidays;
}

function getDisabledHolidaySet () {
    const now = new Date();
    const currentYear = now.getFullYear();
    const disabled = new Set();
    [currentYear, currentYear + 1].forEach(year => {
        getUSFederalHolidays(year).forEach(d => {
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            disabled.add(`${d.getFullYear()}-${mm}-${dd}`);
        });
    });
    return disabled;
}

export function initCalendar (container, { calendarSelector, AirDatepicker, localeEn, datepickerOptions }) {
    const el = qs(container, calendarSelector);
    if (!el) return;
    if (el._airdp) el._airdp.destroy();

    const holidaySet = getDisabledHolidaySet();
    const userOnRenderCell = datepickerOptions.onRenderCell;

    el._airdp = new AirDatepicker(el, {
        inline: true,
        locale: localeEn,
        minDate: new Date(),
        selectedDates: [new Date()],
        multipleDates: false, // Allow only single date selection
        onRenderCell ({ date, cellType }) {
            if (cellType === 'day') {
                // Disable Sundays
                if (date.getDay() === 0) {
                    return { disabled: true, classes: 'is-sunday' };
                }

                // Disable US federal holidays
                const mm = String(date.getMonth() + 1).padStart(2, '0');
                const dd = String(date.getDate()).padStart(2, '0');
                const key = `${date.getFullYear()}-${mm}-${dd}`;

                if (holidaySet.has(key)) {
                    const result = { disabled: true, classes: '-holiday-' };
                    if (userOnRenderCell) {
                        const userResult = userOnRenderCell({ date, cellType });
                        return { ...result, ...userResult };
                    }
                    return result;
                }
            }
            if (userOnRenderCell) return userOnRenderCell({ date, cellType });
        },
        onSelect ({ date, formattedDate, datepicker }) {
            el.dispatchEvent(new CustomEvent('calendar:changed', { bubbles: true }));
            //const dateISO = (Array.isArray(date) && date.length > 0) ? new Date(Date.UTC(date[0].getFullYear(), date[0].getMonth(), date[0].getDate())).toISOString().slice(0, 10) : null;
            const d = el._airdp?.selectedDates?.[0];
            const dateISO = d ? new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())).toISOString().slice(0, 10) : null;

                        
            console.log('Date selected:', dateISO);

            if (dateISO) {
                const stepCal = qs(container, '[data-calendar]');
                const slotsContainer = qs(stepCal, '.book__calendarItems');
                if (slotsContainer) {
                    slotsContainer.innerHTML = '<div class="col-12 text-center text-muted py-3">Loading…</div>';
                    
                    fetchTimeSlots(dateISO)
                        .then(html => {
                            slotsContainer.innerHTML = html;
                            
                            // Re-bind radio button listeners after loading new slots
                            const radios = qsa(slotsContainer, 'input[type="radio"]');
                            initClickTimeSlots(container, radios);
                            
                        })
                        .catch(error => {
                            console.error('Fetch time slots failed', error);
                            slotsContainer.innerHTML = '<div class="col-12 text-danger py-3">Failed to load availability.</div>';
                        });
                }
            }
        },
        ...datepickerOptions
    });
}